


















































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProjectService } from '@store/service/ProjectService';
import { debounce, isEqual, cloneDeep } from 'lodash';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    data() {
        return {
            price: 100,
            rowsForm: [],
            prevPlanData: null,
            addRowData: null,
            addRowForm: {
                description: '',
                expenses: 0,
                comments: '',
            },
        };
    },

    mounted() {
        this.rowsForm = this.planData;
    },

    created() {
        this.projectService = new ProjectService(this.$store);
    },

    methods: {
        clearAddRowForm() {
            this.addRowForm.description = '';
            this.addRowForm.expenses = '0';
            this.addRowForm.comments = '';

            // v-money prevent the v-model from updating, that why we set is like this.
            this.$refs.addExpenses.$el.getElementsByTagName('input')[0].value = 0;
        },

        deleteAddRowForm() {
            this.clearAddRowForm();
            
            if (this.addRowData) {
                this.projectService.deletePlanDataRow(this.projectId, this.type, this.addRowData.id).then(() => {
                    this.addRowData = null;
                });
            }
        },

        addRow() {
            if (!this.addRowFormHasData)
                return;

            this.rowsForm.push(this.addRowData);
            this.addRowData = null;
            this.clearAddRowForm();
        },

        deleteRow(row, rowIndex) {
            this.projectService.deletePlanDataRow(this.projectId, this.type, row.id).then(() => {
                this.rowsForm.splice(rowIndex, 1);
            });
        },

        updatePlanDataRow(row) {
            let updatedPlanData = {
                description: row.description,
                expenses: row.expenses.replace(/\./g, ""),
                comments: row.comments,
            };

            this.projectService.updatePlanDataRow(this.projectId, this.type, row.id, updatedPlanData);
        }
    },

    watch: {
        planData(newData) {
            this.rowsForm = newData;
        },

        rowsForm: {
            deep: true,
            handler: debounce(function(newValue) { 
                const oldValue = this.prevPlanData;

                if (oldValue) {
                    for (let i = 0; i < newValue.length; i++) {
                        if (!isEqual(newValue[i], oldValue[i])) {
                            this.updatePlanDataRow(newValue[i]);
                        }
                    }
                }

                this.prevPlanData = cloneDeep(newValue);
            }, 500)
        },

        addRowForm: {
            deep: true,
            handler: debounce(function(newValue, oldValue) {
                if (!this.addRowFormHasData && this.addRowData) {
                    this.projectService.deletePlanDataRow(this.projectId, this.type, this.addRowData.id).then(() => {
                        this.addRowData = null;
                    });
                    return;
                }

                if (this.addRowFormHasData) {
                    if (!this.addRowData) {
                        this.projectService.addPlanDataRow(this.projectId, this.type, newValue).then(response => {
                            this.addRowData = response.data;
                        });
                    } else {
                        this.projectService.updatePlanDataRow(this.projectId, this.type, this.addRowData.id, newValue).then(response => {
                            this.addRowData = response.data;
                        });
                    }
                }
            }, 500)
        }
    },

    computed: {
        cClass() {
            const classes = ['custom-plan'];

            if (this.formDisabled)
                classes.push('table--disabled')

            return classes.join(' ');
        },

        hasData() {
            return this.rowsFormHasData || this.addRowFormHasData;
        },

        rowsFormHasData() {
            return this.rowsForm.length > 0;
        },

        addRowFormHasData() {
            return this.addRowForm.description !== '' ||
                this.addRowForm.expenses !== '0' ||
                this.addRowForm.comments !== ''
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class CustomPlan extends Vue {
    @Prop({ type: Array, required: true }) planData!: any;
    @Prop({ type: Number, required: true }) projectId!: Number;
    @Prop({ type: String, required: true }) type!: string;
    @Prop({ type: String, required: true }) expenses!: string;
    @Prop({ type: Boolean, required: false, default: false }) formDisabled!: Boolean;
}

